module.exports = __webpack_public_path__ + "img/quiz_resit.604b19a0.png";